import { FC, memo } from 'react';
import ScriptInjector from 'src/features/common/components/ScriptInjector';
import { GAINSIGHT_SCRIPT_ID, gainsightScript } from 'src/features/common/components/gainsight/utils';

const GainsightScriptInjector: FC = () => {
  return <ScriptInjector code={gainsightScript} id={GAINSIGHT_SCRIPT_ID} />;
};

export default memo(GainsightScriptInjector);
